import React from 'react';
import ShopCard from 'components/blocks/shopCard';
import './ShopPage.scss';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
    asyncCreatePurchase,
    asyncDeletePurchase,
    asyncFetchProducts,
} from 'store/reducers/products/thunks';
import { IProduct } from 'store/reducers/products/types';

function ShopPage(): React.ReactElement {
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        dispatch(asyncFetchProducts());
    }, [dispatch]);
    const { products } = useAppSelector(state => state.productsStore);

    const productAction = React.useCallback(
        (product: IProduct): void => {
            if (product.purchases.length > 0)
                dispatch(
                    asyncDeletePurchase({
                        id: product.purchases[0],
                        product: product.id,
                    })
                );
            else dispatch(asyncCreatePurchase(product.id));
        },
        [dispatch]
    );

    return (
        <div className="card-flexbox">
            {products.map(product => {
                return (
                    <ShopCard
                        key={product.id}
                        name={product.name}
                        imageURL={product.imageURL}
                        price={product.price}
                        available
                        purchased={product.purchases.length > 0}
                        onClick={() => productAction(product)}
                    />
                );
            })}
        </div>
    );
}

export default React.memo(ShopPage);
